export const FETCH_PROPOSED_EXAM_PRICE_PENDING = 'FETCH_PROPOSED_EXAM_PRICE_PENDING'
export const FETCH_PROPOSED_EXAM_PRICE_FULFILLED = 'FETCH_PROPOSED_EXAM_PRICE_FULFILLED'
export const FETCH_PROPOSED_EXAM_PRICE_REJECTED = 'FETCH_PROPOSED_EXAM_PRICE_REJECTED'

export const FETCH_AGGREGATED_FEES_PENDING = 'FETCH_AGGREGATED_FEES_PENDING'
export const FETCH_AGGREGATED_FEES_FULFILLED = 'FETCH_AGGREGATED_FEES_FULFILLED'
export const FETCH_AGGREGATED_FEES_REJECTED = 'FETCH_AGGREGATED_FEES_REJECTED'
